export default "__VITE_ASSET__BVXWaNY8__"